import React from 'react'
import { useState, useEffect } from 'react';
import ProductGrid4 from '../../components/public/pages/home/productGrid4';
import InfiniteScroll from 'react-infinite-scroll-component';
import HomeFunctions from '../../functions/public/home';
import DocumentMeta from 'react-document-meta';

const Newonkaay = () => {
    const [products,setProducts] = useState([]);
    const [page, setPage] = useState(0);
    const [HasMore, setHasMore] = useState(true);
    const [collection,setCollection] = useState({
      id : 0,
      title:"New on Kaay",
      discription:""
    });
    const getmore = ()=>{
      HomeFunctions.Newonkaaypage(page,setPage,products,setProducts,setHasMore);
    }
    useEffect(() => {
      HomeFunctions.Newonkaaypage(page,setPage,products,setProducts,setHasMore);
    },[])
    const meta = {
      title: 'New Arrivals | Latest & trendy Products on KAAY',
      description: "Discover the latest products from various Brands, local vendors & artists in our New Arrivals section. From clothing, accessories, handmade crafts to unique gifts, there's something for everyone in our constantly updated selection. Our social commerce platform makes it easy for sellers to showcase their products & reach a wider audience.",
      canonical: window.location.href
      /*canonical: 'http://example.com/path/to/page',
      meta: {
          charset: 'utf-8',
          name: {
              keywords: 'react,meta,document,html,tags'
          }
      }*/
    }
  return (
    <div>
      <DocumentMeta {...meta} />
        <div style={{ margin:"0px 40px"}}>
            <div className='collection_heading'>
                <h3>{collection.title}</h3>
                <p>{collection.discription}</p>
            </div>
            <InfiniteScroll 
                dataLength={products.length}
                next={getmore}
                hasMore={HasMore}
                loader={<h1></h1>}
            >
              <ProductGrid4 Products={products} Columns={5}/>
            </InfiniteScroll>
        </div>
    </div>
  )
}

export default Newonkaay
